import { gql } from "graphql-request";

// AI Chat用のクエリとミューテーション

export const GET_MY_CHAT_SESSIONS = gql`
  query GetMyChatSessions {
    myChatSessions {
      id
      userId
      lessonTopic
      title
      createdAt
      updatedAt
    }
  }
`;

export const GET_CHAT_SESSION = gql`
  query GetChatSession($sessionId: Int!) {
    chatSession(sessionId: $sessionId) {
      id
      userId
      lessonTopic
      title
      createdAt
      updatedAt
      messages {
        id
        sessionId
        role
        content
        createdAt
      }
    }
  }
`;

export const CREATE_CHAT_SESSION = gql`
  mutation CreateChatSession($input: CreateChatSessionInput!) {
    createChatSession(input: $input) {
      id
      userId
      lessonTopic
      title
      createdAt
      updatedAt
    }
  }
`;

export const ADD_CHAT_MESSAGE = gql`
  mutation AddChatMessage($input: AddChatMessageInput!) {
    addChatMessage(input: $input) {
      id
      sessionId
      role
      content
      createdAt
    }
  }
`;

export const RECORD_CHAT_MESSAGE_FEEDBACK = gql`
  mutation RecordChatMessageFeedback($input: RecordChatMessageFeedbackInput!) {
    recordChatMessageFeedback(input: $input)
  }
`;

export const UPDATE_CHAT_SESSION_TITLE = gql`
  mutation UpdateChatSessionTitle($sessionId: Int!, $title: String!) {
    updateChatSessionTitle(sessionId: $sessionId, title: $title)
  }
`;

export const DELETE_CHAT_SESSION = gql`
  mutation DeleteChatSession($sessionId: Int!) {
    deleteChatSession(sessionId: $sessionId)
  }
`;
